import * as o from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/ArrowsClockwise.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(c, { ref: s, ...e, weights: t }));
r.displayName = "ArrowsClockwiseIcon";
const m = r;
export {
  m as ArrowsClockwise,
  r as ArrowsClockwiseIcon
};
